import React, { useState, useEffect } from "react";
import { Form, InputNumber } from "antd";
import { elvis } from "../../Utils";
import Map2 from "../Map/Map2";

const PeopleDamageForm = props => {
    const [form] = Form.useForm();
    const isEditMode = props.isEditMode || false;

    useEffect(() => {
        if (props.record.damage) {
            form.setFieldsValue({
                numberOfDead: props.record.damage.numberOfDead,
                numberOfInjured: props.record.damage.numberOfInjured,
                numberOfMissing: props.record.damage.numberOfMissing,
            });
        }
    }, [props.record.damage, form]);

    // Handle form field changes
    const onValuesChange = (changedValues, allValues) => {
        if (!isEditMode) return;
        const newDamage = { ...props.record };
        newDamage.damage.numberOfDead = elvis(allValues.numberOfDead);
        newDamage.damage.numberOfInjured = elvis(allValues.numberOfInjured);
        newDamage.damage.numberOfMissing = elvis(allValues.numberOfMissing);
        newDamage.damage.damageClass = props.damageClass;
        
        // Check if form is valid
        form.validateFields()
            .then(() => {
                newDamage.valid = true;
                props.parentCallback(newDamage);
            })
            .catch(() => {
                newDamage.valid = false;
                props.parentCallback(newDamage);
            });
    };

    return (
        <Form 
            form={form}
            layout="horizontal"
            onValuesChange={onValuesChange}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            name="peopleDamageForm"
        >
            <Form.Item label="N. of dead" name="numberOfDead">
                <InputNumber disabled={!isEditMode} />
            </Form.Item>
            <Form.Item label="N. of injured" name="numberOfInjured">
                <InputNumber disabled={!isEditMode} />
            </Form.Item>
            <Form.Item label="N. of missing" name="numberOfMissing">
                <InputNumber disabled={!isEditMode} />
            </Form.Item>
        </Form>
    );
};

export default PeopleDamageForm;